import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  procedimentosSearchParameters: {
    fgSefisc: "",
    flagStProcedimento: "",
    sqTipoCarga: "",
    tipoAcaoFiscal: "",
  },
  filterButton: false,
};

const procedimentosSearchSlice = createSlice({
  name: "procedimentosSearch",
  initialState,
  reducers: {
    salvarEstado(state, action) {
      state.procedimentosSearchParameters = { ...action.payload };
    },
    estadoBotao(state, action) {
      state.filterButton = action.payload;
    },
    reset: () => initialState,
  },
});

export const procedimentosSearchActions = procedimentosSearchSlice.actions;

export default procedimentosSearchSlice.reducer;
